import React from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function RentalItem({
  title,
  description,
  price,
  value,
  onChange,
  disabled = false,
  maxValue = Infinity,
  validationMessage = '',
  priceDisplay = null,
  highlight = false,
  hidePrices = false
}) {
  const increment = () => {
    if (value < maxValue) {
      onChange(value + 1);
    }
  };
  const decrement = () => {
    if (value > 0) {
      onChange(value - 1);
    }
  };
  return <div className={`p-4 rounded-md ${highlight ? 'bg-blue-50 border border-blue-300' : 'bg-slate-50'}`} data-id="element-1661">
      <div className="flex justify-between" data-id="element-1662">
        <div data-id="element-1663">
          <h3 className="font-medium text-slate-900" data-id="element-1664">{title}</h3>
          <p className="text-sm text-slate-500 mt-1" data-id="element-1665">{description}</p>
          {validationMessage && value === maxValue && maxValue > 0 && <p className="text-xs text-red-600 mt-1" data-id="element-1666">{validationMessage}</p>}
        </div>
        {!hidePrices && <div className="text-right" data-id="element-1667">
            <div className="font-medium text-slate-900" data-id="element-1668">
              {priceDisplay || `$${price.toFixed(2)} per ring`}
            </div>
          </div>}
      </div>
      <div className="mt-4 flex items-center" data-id="element-1669">
        <button type="button" onClick={decrement} disabled={value === 0} className={`p-1 rounded-full ${value === 0 ? 'text-slate-400 cursor-not-allowed' : 'text-slate-600 hover:bg-slate-200'}`} data-id="element-1670">
          <MinusIcon size={20} data-id="element-1671" />
        </button>
        <div className="mx-3 w-12 text-center font-medium" data-id="element-1672">{value}</div>
        <button type="button" onClick={increment} disabled={disabled || value >= maxValue} className={`p-1 rounded-full ${disabled || value >= maxValue ? 'text-slate-400 cursor-not-allowed' : 'text-slate-600 hover:bg-slate-200'}`} data-id="element-1673">
          <PlusIcon size={20} data-id="element-1674" />
        </button>
      </div>
    </div>;
}